import { render, staticRenderFns } from "./video-tree.vue?vue&type=template&id=6b9f88c4&scoped=true&"
import script from "./video-tree.vue?vue&type=script&lang=js&"
export * from "./video-tree.vue?vue&type=script&lang=js&"
import style0 from "./video-tree.vue?vue&type=style&index=0&id=6b9f88c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9f88c4",
  null
  
)

export default component.exports